import { css } from 'goober';
import React, { useEffect, useState } from 'react';
import colors from '../../styles/colors';
import font from '../../styles/font';
import { fadeIn, fadeOut } from '../../styles/keyframes';
const VariantWrapper = (overflow) => css `
  height: 80px;
  width: 100%;
  padding: 0 20px;
  overflow: ${overflow};
  position: relative;
`;
const VariantContainer = (mode) => css `
  height: 80px;
  transition: all 500ms cubic-bezier(0.37, 1.4, 1, 1.03);
  transform: translateY(${mode === "FOCUS" /* FOCUS */ ? 0 : 100}%);
`;
const TitleContainer = (mode) => css `
  position: absolute;
  left: 0;
  top: 0;
  width: 80%;
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 20px;
  animation-name: ${mode === "FOCUS" /* FOCUS */ ? fadeOut : fadeIn};
  animation-duration: 200ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
`;
const Title = css `
  font-size: ${font.fontMedium};
  line-height: 24px;
  color: ${colors.white};
  font-weight: ${font.fontWtNormal};
`;
const VariantsLayout = (props) => {
    const { mode, title, onToggleMode, children } = props;
    const [overflow, setOverflow] = useState('hidden');
    useEffect(() => {
        if (mode === "NORMAL" /* NORMAL */) {
            setOverflow('hidden');
        }
    }, [mode]);
    const handleOverflow = () => {
        if (mode === "NORMAL" /* NORMAL */)
            return;
        setOverflow('visible');
    };
    const handleTap = () => {
        if (mode === "NORMAL" /* NORMAL */) {
            onToggleMode();
        }
    };
    return (React.createElement("div", { className: VariantWrapper(overflow), onTransitionEnd: handleOverflow, onClick: handleTap },
        React.createElement("div", { className: TitleContainer(mode) },
            React.createElement("h1", { className: Title }, title)),
        React.createElement("div", { className: VariantContainer(mode) }, children)));
};
export default VariantsLayout;
//# sourceMappingURL=index.js.map